<template>
  <Modal v-model="model"  sticky reset-drag-position title="导入号码" @on-cancel="cancel" footer-hide :mask="false" draggable class="import_out_call">
    <div class="import_call_left">
      <div class="font_style_set">客户号码来源:</div>
      <Select v-model="numberFrom" style="width: 250px" @on-change="changeType">
        <Option v-for="(option, index) in numberFromList" :value="option.id" :key="index">{{option.name}}</Option>
      </Select>
    </div>
    <div class="import_call_left" v-show="showExcel">
      <div class="font_style_set">上传Excel文件:</div>
      <Upload :action="baseUploadUrl" :on-success="handleSuccess" :show-upload-list="showUploadList" :on-error="handleFail" >
        <Input readonly="readonly" icon="ios-cloud-upload-outline" placeholder="文件上传"/>
      </Upload>
    </div>
    <div class="import_warning">
      <p style="color: red">提示：</p>
      <p style="color: red">1、Excel导入的客户号码数据会自动过滤掉无效的号码和重复的号码</p>
      <p style="color: red">2、同一个呼出计划中导入相同的呼出号码会自动过滤，保留一个</p>
      <p style="color: red">3、号码为空的客户不导入</p>
    </div>
    <div class="btn_template">
      <a v-show="showExcel" style="float: left" href="javascript:void(0)" @click="downLoad">下载Excel导入号码模板</a>
      <Button type="primary" class="submit_btn" @click="cancel()">关闭</Button>
      <Button type="primary" v-show="!showExcel"  class="cancel_btn" @click="getCustomerInfo">下一步</Button>
    </div>
    <searchCustomerInfoPop  @closeCustomerInfo="closeCustomerInfo" :taskTypeForCust="taskTypeForCust" :selectCallId="selectCallId" :isCallPlan="isCallPlan" :showCustomerInfo="showCustomerInfo"></searchCustomerInfoPop>
  </Modal>
</template>

<script>
  import searchCustomerInfoPop from '@/components/customerMange/SearchCustomerInfoPop.vue'
    export default {
      name: "ImportNumberPop",
      props: {
        showImportCallPop:Boolean,
        callId:String,
        taskType:String,
      },
      components:{
        searchCustomerInfoPop
      },
      data(){
          return {
            taskTypeForCust:'',
            selectCallId:'',
            isCallPlan:false,
            showExcel:false,
            showCustomerInfo:false,
            model:false,
            numberFrom:'0',
            numberFromList:[{'id':'0','name':'系统已有客户'},{'id':'1','name':'外部Excel导入'}],
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            percentage:0,
            // customerState 1 是公海客户  moduleId 1 客户模块 3 服务记录模块
            downUrl:this.baseURL+"common/downloadTemplate.json?companyId="+localStorage.getItem("companyId")+"&customerState=0&moduleId=1",
            baseUploadUrl:"",
            showUploadList:false,
          }
      },
      methods:{
        closeCustomerInfo:function(flag){
          this.showCustomerInfo=false;
          if(flag){
            this.$emit("closeCallEditPop",flag);
          }
        },
        downLoad() {
          let iframe = document.createElement("iframe")
          iframe.src=this.downUrl
          iframe.id = 'down'
          let frameId = document.getElementById("down")
          if (frameId) {
            frameId.parentNode.removeChild(frameId);
          }
          document.body.appendChild(iframe)
        },
        cancel:function(){
          this.$emit("closeCallEditPop",false);
        },
        getCustomerInfo:function(){
          this.showCustomerInfo=true;
          this.isCallPlan=true;
          this.selectCallId=this.callId;
          this.taskTypeForCust=this.taskType;
        },
        changeType:function () {
          if(this.numberFrom=='1'){
            this.showExcel=true;
          }else{
            this.showExcel=false;
          }
        },
        handleSuccess:function (res) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.percentage=100;
          let that=this;
          setTimeout(function () {
            that.$emit("closeCallEditPop",true);
          },1000);
        },
        handleFail:function (error, file) {
          this.$Modal.info({
            title:'失败提示',
            content:file.response.msg
          });
          this.percentage=-10;
        }
      },
      watch:{
        showImportCallPop:function () {
          this.model=this.showImportCallPop;
          this.numberFrom='0';
          this.showExcel=false;
          this.baseUploadUrl=this.baseURL+"common/importCalltask.json?token="+localStorage.getItem("token")+"&taskId="+this.callId+"&source=2&taskType="+this.taskType;
          this.type=[];
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/callManage/ImportNumberPop.vue